import { config } from '../config';

/**
 * Utilidades para manejo seguro de evidencias de tickets
 * Estas son diferentes a las evidencias de seguridad eliminadas
 */

/**
 * Crea una URL de objeto para previsualización segura de evidencias
 * @param {string} evidenceUrl - URL de la evidencia
 * @returns {Promise<string>} - URL del objeto para previsualización
 */
export async function createEvidenceObjectUrl(evidenceUrl) {
    try {
        const token = (localStorage.getItem('token') || sessionStorage.getItem('token'));
        if (!token) {
            throw new Error('No se encontró token de autenticación');
        }

        // Determinar el endpoint correcto según el tipo de evidencia
        let apiUrl;
        if (evidenceUrl.includes('/securefile/preview/evidencias/')) {
            // Evidencias de tickets
            const fileName = evidenceUrl.split('/').pop();
            apiUrl = `${config.api.baseURL}/securefile/evidence/${fileName}`;
        } else if (evidenceUrl.includes('/securefile/preview/evidencias-seguridad/')) {
            // Evidencias de seguridad
            const fileName = evidenceUrl.split('/').pop();
            apiUrl = `${config.api.baseURL}/securefile/evidence-security/${fileName}`;
        } else {
            // Otros archivos seguros
            apiUrl = `${config.api.baseURL.replace('/api', '')}${evidenceUrl}`;
        }

        const response = await fetch(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error al cargar evidencia: ${response.status}`);
        }

        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (error) {
        console.error('Error al crear URL de objeto para evidencia:', error);
        throw error;
    }
}

/**
 * Descarga una evidencia de ticket a través de la API
 * @param {string} evidenceUrl - URL de la evidencia
 * @param {string} fileName - Nombre del archivo para descargar
 */
export async function downloadEvidenceViaAPI(evidenceUrl, fileName = 'evidencia') {
    try {
        const token = (localStorage.getItem('token') || sessionStorage.getItem('token'));
        if (!token) {
            alert('No se encontró token de autenticación');
            return;
        }

        // Determinar el endpoint correcto según el tipo de evidencia
        let apiUrl;
        if (evidenceUrl.includes('/securefile/preview/evidencias/')) {
            // Evidencias de tickets
            const fileNameFromUrl = evidenceUrl.split('/').pop();
            apiUrl = `${config.api.baseURL}/securefile/evidence/${fileNameFromUrl}`;
        } else if (evidenceUrl.includes('/securefile/preview/evidencias-seguridad/')) {
            // Evidencias de seguridad
            const fileNameFromUrl = evidenceUrl.split('/').pop();
            apiUrl = `${config.api.baseURL}/securefile/evidence-security/${fileNameFromUrl}`;
        } else {
            // Otros archivos seguros
            apiUrl = `${config.api.baseURL.replace('/api', '')}${evidenceUrl}`;
        }

        const response = await fetch(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error al descargar evidencia: ${response.status}`);
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        // Crear enlace de descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Limpiar URL del objeto
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error al descargar evidencia:', error);
        alert('Error al descargar la evidencia');
    }
}

